/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/unbound-method */
import { ReactNode, useContext, useEffect } from 'react';

import { UserContext } from './user-context-provider';
import { validateJwtAndAuthorize } from './validate-jwt-and-authorize';

/**
 * `AuthenticationGuard` is a component responsible for verifying the user's
 * authentication using an authorization guard. Upon successful verification,
 * it updates the user context with the JWT and the isAdmin property.
 *
 * @component
 *
 * @param {Object} props - Component properties.
 * @param {ReactNode} props.children - The child elements to be rendered within the component.
 *
 * @returns {JSX.Element} - Returns the child elements once authentication is verified.
 *
 * @example
 * <AuthenticationGuard>
 *   <ProtectedComponent />
 * </AuthenticationGuard>
 */
export const AuthenticationGuard = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const { setJwt, setIsAdmin } = useContext(UserContext);

  const onAuthenticationVerified = (jwt: string, isAdmin: boolean) => {
    setJwt(jwt);

    setIsAdmin(isAdmin);
  };

  const init = () => {
    validateJwtAndAuthorize(onAuthenticationVerified);
  };

  useEffect(() => {
    init();
  }, []);

  return <>{children}</>;
};
